import type { SvgIconProps } from '@mui/material';
import { SvgIcon } from '@mui/material';

export function CohortHistoryChartIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M3 3V21H21"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7 17L11 12L15 15L21 8"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.5 4.5V7L17 8.25"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle
          cx="15.5"
          cy="7"
          r="4"
          stroke="currentColor"
          strokeWidth="1.6"
        />
      </svg>
    </SvgIcon>
  );
}
